import { render, staticRenderFns } from "./HRSalaryList.vue?vue&type=template&id=6fd3780a&"
import script from "./HRSalaryList.vue?vue&type=script&lang=js&"
export * from "./HRSalaryList.vue?vue&type=script&lang=js&"
import style0 from "./HRSalaryList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports